/* eslint linebreak-style: ["error", "windows"] */
import React from 'react';
import Login_user from '../components/Login_user';
import logo from '../assets/images/un-logo.svg';

function Login() {
  return (
  <div className="auth-wrapper">
    <div className="auth-inner">
      <img src={logo} alt="Logo Universidad del Norte"/>
      <Login_user/>
    </div>
  </div>
  );
}

export default Login;
